(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/constants.js');

'use strict';

const ONE_HOUR = 60 * 60 * 1000;
const ONE_MONTH = 30 * 24 * ONE_HOUR;
const LENGTH_OF_COMPETITION_PREPHASE = 2 * ONE_MONTH;
const OverviewUserState = Object.freeze({
  IS_NOT_LOGGED_IN: 'is-not-logged-in',
  IS_NOT_REGISTERED: 'is-not-registered',
  HAS_NO_CURRENT_BET: 'has-no-current-bet',
  HAS_CURRENT_BET: 'has-current-bet'
});
setGlobal('svs.components.marketplaceCompetition.overviewHero.constants', {
  ONE_HOUR,
  ONE_MONTH,
  LENGTH_OF_COMPETITION_PREPHASE,
  OverviewUserState
});

 })(window);